import React from 'react';
import {
  Button,
} from 'react-bootstrap5';
import PropTypes from 'prop-types';

export default function Thankyou({ closeForm }) {
  return (
    <div>
      <h1>Thank you!</h1>
      <div className="text-center mt-4">
        <Button onClick={closeForm}>
          Close
        </Button>
      </div>
    </div>
  );
}

Thankyou.propTypes = {
  closeForm: PropTypes.func.isRequired,
};
